<style scoped lang="less">
.chart{
  margin-top: 24px;
}
</style>
<script>
import methods from './methods.js'
import Container from "modules/shop/_id/components/container/index.vue";
import ButtonGroup from "modules/shop/_id/components/buttonGroup/index.vue";
import Chart from './components/chart/index.vue'
export default {
  name: "price",
  components: {ButtonGroup, Container,Chart},
  mixins: [methods]
}
</script>
<template>
   <Container icon="https://s6.bihukankan.com/img/1695710276512.svg" title="商品价格分析">
    <template #head>
      <ButtonGroup v-model="type" :list="buttonList" @change="getData"/>
    </template>
    <Chart :type="type" :data="chartDataApi" class="chart"/>
  </Container>
</template>

